// extracted by mini-css-extract-plugin
export default {"productDescription":"cca-z","featuredDescription":"dca-z","description":"eca-z","more":"fca-z","descriptionSku":"gca-z"};